/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1BannerQueryResponse,
  GetApiV1BannerQueryParams,
  GetApiV1Banner401,
  GetApiV1Banner500,
} from "../../types/bannerRegistroController/GetApiV1Banner.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1Banner } from "../../clients/bannerRegistroController/getApiV1Banner.ts";

export const getApiV1BannerQueryKey = (params?: GetApiV1BannerQueryParams) =>
  [{ url: "/api/v1/banner" }, ...(params ? [params] : [])] as const;

export type GetApiV1BannerQueryKey = ReturnType<typeof getApiV1BannerQueryKey>;

export function getApiV1BannerQueryOptions(
  params?: GetApiV1BannerQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1BannerQueryKey(params);
  return queryOptions<
    GetApiV1BannerQueryResponse,
    ResponseErrorConfig<GetApiV1Banner401 | GetApiV1Banner500>,
    GetApiV1BannerQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1Banner(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma lista paginada de banners. Filtra por empresa, título e status. **(Requer Authorization para autenticação)**
 * @summary Listar banners (Requer Authorization para autenticação)
 * {@link /api/v1/banner}
 */
export function useGetApiV1Banner<
  TData = GetApiV1BannerQueryResponse,
  TQueryData = GetApiV1BannerQueryResponse,
  TQueryKey extends QueryKey = GetApiV1BannerQueryKey,
>(
  params?: GetApiV1BannerQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1BannerQueryResponse,
        ResponseErrorConfig<GetApiV1Banner401 | GetApiV1Banner500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1BannerQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1BannerQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1Banner401 | GetApiV1Banner500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
